import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { appConfig } from './app/app.config';

LicenseManager.setLicenseKey('CompanyName=Closered Company Limited,LicensedApplication=Ariifu,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036628,SupportServicesEnd=10_January_2024_[v2]_MTcwNDg0NDgwMDAwMA==da59c24e66905cda6718ff1ed86f108a');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
